import type { ICampaignConfig, ISubFetchConfig } from './campaignConfig.types';

export interface IUrlTemplateParams {
  host: string;
  [key: string]: string | number;
}

const buildUrlFromTemplate = (template: string, params: IUrlTemplateParams): string => {
  let host = params.host;
  if (!host.startsWith('http')) host = `https://${host}`;
  if (!host.endsWith('/')) host += '/';

  return Object.entries(params).reduce(
    (url, [key, value]) => url.replace(`\${${key}}`, String(value)),
    template.replace('${host}', host)
  );
};

export const buildMainFetchUrl = (config: ICampaignConfig, params: IUrlTemplateParams): string => 
  buildUrlFromTemplate(config.mainFetch.urlTemplate, params);

export const buildSubFetchUrl = (subFetch: ISubFetchConfig, params: IUrlTemplateParams): string => 
  buildUrlFromTemplate(subFetch.urlTemplate, params);
